export default {"src":"/_next/static/media/MQ.fab52ef7.svg","height":18,"width":18};